import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-body" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dismissible_alert = _resolveComponent("dismissible-alert")!
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_modal_base = _resolveComponent("modal-base")!

  return (_openBlock(), _createBlock(_component_modal_base, { onDismiss: _ctx.dismiss }, {
    title: _withCtx(() => [
      _createTextVNode(" 確認 ")
    ]),
    "modal-content": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, [
          _createTextVNode("「"),
          _createElementVNode("span", {
            textContent: _toDisplayString(_ctx.title)
          }, null, 8, _hoisted_2),
          _createTextVNode(" 」を削除してもよろしいですか？")
        ]),
        _createVNode(_component_dismissible_alert, {
          color: "danger",
          message: _ctx.requestError,
          onDismiss: _cache[0] || (_cache[0] = ($event: any) => (_ctx.requestError = null))
        }, null, 8, ["message"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
        }, "キャンセル"),
        _createVNode(_component_loading_button, {
          color: "danger",
          loading: _ctx.isWaiting,
          onClick: _ctx.deleteNotice
        }, {
          default: _withCtx(() => [
            _createTextVNode("削除")
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ])
    ]),
    _: 1
  }, 8, ["onDismiss"]))
}